import { render, staticRenderFns } from "./OpHistory.vue?vue&type=template&id=83654740&scoped=true&"
import script from "./OpHistory.vue?vue&type=script&lang=js&"
export * from "./OpHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83654740",
  null
  
)

export default component.exports